export const UTILITY_TARIFF_GROUPS_LIST_PATH = '/utility_tariff_groups'

export const UTILITY_TARIFF_GROUPS_ALL_RATE_ROWS_PATH = '/utility_tariff_groups/all_rate_rows'

export const UTILITY_TARIFFS_BASE_PATH = '/utility_tariffs'
